<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true" :model="filters">
        <el-form-item label="日期">
          <el-date-picker
            v-model="search.checkInRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getOrders">查询</el-button>
        </el-form-item>
        <!-- <el-form-item v-if="isSuperAdmin">
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>-->
      </el-form>
    </el-col>

    <el-tabs v-model="activeTab" @tab-click="onTabChange">
      <el-tab-pane label="日级数据" name="date"></el-tab-pane>
      <el-tab-pane label="月级数据" name="month"></el-tab-pane>
      <el-tab-pane label="年级数据" name="year"></el-tab-pane>
    </el-tabs>
    <!--列表-->
    <el-table
      :data="orders"
      highlight-current-row
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
      fixed
    >
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <el-table-column type="index" width="70"></el-table-column>
      <el-table-column
        prop="form"
        width="70"
        label="渠道"
        :formatter="(row) => (fromMap[row.form])"
      ></el-table-column>
      <el-table-column prop="check_in_date" label="入住日期"></el-table-column>
      <el-table-column prop="orderCount" label="订单数"></el-table-column>
      <el-table-column prop="price" label="总价"></el-table-column>
      <el-table-column prop="commission" label="总佣金"></el-table-column>
      <el-table-column prop="roomStay" label="间夜数"></el-table-column>

      <!-- <el-table-column label="操作" width="150">
         <template scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="handleSend(scope.$index, scope.row)">发送</el-button>
        </template>
      </el-table-column>-->
    </el-table>

    <el-col :span="24" class="toolbar">
      <!-- <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      >-->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="20"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>
  </section>
</template>

<script>
import util from "../../common/js/util";
import NProgress from "nprogress";
import { adminApi, hotelApi, orderApi } from "../../api/api";
import { mapGetters } from "vuex";
import fecha from "fecha";
import { tzOrderStatusMap, fromMap, fromNameMap } from "../../constant";
export default {
  data() {
    return {
      activeTab: 'date',
      fromMap,
      fromNameMap,
      search: {
        checkInRange: [new Date(), new Date()],
      },
      stausMap: {},
      hotelMap: {},
      hotels: [],
      filters: {
        name: "",
      },
      orders: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        //   role: [{ required: true, message: '请输入角色', trigger: 'blur' }],
      },
      //编辑界面数据
      editForm: {
        note: "",
        discount: 0,
        floorPrice: 0,
        price: 0,
        id: "",
        hotel_id: "",
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        name: "",
        password: "",
        role: 1,
      },
    };
  },
  methods: {
    //性别显示转换
    formatRole: function (row, column) {
      return row.role == 0 ? "超级管理员" : "普通管理员";
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getOrders();
    },
    getOrders() {
      let para = {
        page: this.page,
        search: this.search,
        type: this.activeTab,
      };
      if(!this.search.checkInRange || !this.search.checkInRange[0]){
        para.search.checkInRange = []
      }
      this.listLoading = true;
      NProgress.start();
      orderApi
        .statistics(para)
        .then((res) => {
          this.total = res.data.count;
          res.data.rows.forEach((row) => {
            row.price = row.price / 100;
            // row.floorPrice = row.floorPrice / 100;
            // row.discount = row.discount / 100;
            row.commission = row.commission / 100;
          });
          this.orders = res.data.rows;
        })
        .finally((_) => {
          NProgress.done();
          this.listLoading = false;
        });
    },
    getOrderStatus(row) {
      const map = row.from == 1 ? tzOrderStatusMap : {};
      return map[row.orderStatus] || row.orderStatus;
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = Object.assign(this.editForm, row);
    },
   
    selsChange: function (sels) {
      this.sels = sels;
    },
    getHotelMap() {
      hotelApi.listMap().then(({ data }) => {
        this.hotelMap = data;
        this.hotels = Object.entries(data);
      });
    },
    onTabChange(tab){
      this.activeTab = tab.name
      this.getOrders();
    }
  },
  created() {
    this.fecha = fecha;
  },
  mounted() {
    this.getHotelMap();
    this.getOrders();
  },
  computed: {
    ...mapGetters(["getUserInfo", "isSuperAdmin"]),
  },
};
</script>

<style scoped>
.long-select {
  width: 600px;
}
</style>



// WEBPACK FOOTER //
// statistic.vue?27d47995